import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';

import { HelpCenterUrls } from 'app/utils/help-center';

import {
  ModalSimpleSocialComponent,
  ModalSimpleSocialData,
} from '../modal-simple-social/modal-simple-social.component';
import WebsocketHelper from '../websocket/websocket-helper';

import { SceneService } from './scene.service';
import { BlackSimpleToasterService } from './toasters/black-simple-toaster.service';

@Injectable({
  providedIn: 'root',
})
export class WebsocketTimerService {
  private websocketHelper = new WebsocketHelper();
  private isDisplayingMessage = false;
  public didAttemptToReconnect = false;
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(
    private toasterBanner: BlackSimpleToasterService,
    private dialog: MatDialog,
    private store: Store,
    private sceneService: SceneService,
  ) {}

  public startTrackingReconnectAttempts(): void {
    if (this.websocketHelper.isAttemptingToReconnect()) {
      if (this.websocketHelper.didTimeExpired()) {
        //show message failed to reconnect message
        this.stopTrackingReconnectAttempts();
        this.showFailedConnectionError();
      } else {
        //show attempting to reconnect banner
        this.showMessage('Looks like we lost connection. Attempting to reconnect...');
      }
    } else if (!this.didAttemptToReconnect) {
      this.websocketHelper.startReconnecting();
      this.didAttemptToReconnect = true;
    }
  }

  public stopTrackingReconnectAttempts(): void {
    //stop reconnecting count and remove all banners
    this.websocketHelper.stopReconnecting();
    this.hideMessage();
  }

  public didReconnect(): void {
    this.didAttemptToReconnect = false;
    this.websocketHelper.stopReconnecting();
    this.hideMessage();
    this.showMessage('Reconnected Successfully!');

    setTimeout(() => {
      this.hideMessage();
    }, 3 * 1000);
  }

  private showMessage(message: string) {
    if (!this.isDisplayingMessage) {
      this.isDisplayingMessage = true;
      this.toasterBanner.throw(message, '');
    }
  }

  private hideMessage() {
    this.isDisplayingMessage = false;
    this.toasterBanner.close();
  }

  private showFailedConnectionError() {
    const data: ModalSimpleSocialData = {
      modalTitle: 'Oops! Lost Connection',
      text: 'You are unable to connect to this room. This may be related to a VPN or Network Security settings. Please try to join the room without being on a VPN. If the issue persists, please review this help center article or reach out to <a href="mailto:support@scoot.app">support@scoot.app</a>',
      primaryButtonText: 'Help Center',
    };

    const ref = this.dialog.open<ModalSimpleSocialComponent, ModalSimpleSocialData>(ModalSimpleSocialComponent, {
      panelClass: 'social-modal',
      data: data,
    });

    ref
      .afterClosed()
      // TODO: unsubscrbe?
      .subscribe(() => {
        const url = HelpCenterUrls.SCOOT_PREPARE_NETWORK;
        window.open(url, '_blank')?.focus();
      });
  }

  public destroy(): void {
    this.websocketHelper = new WebsocketHelper();
    this.isDisplayingMessage = false;
    this.didAttemptToReconnect = false;
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
